export function isAntiFraudControl(enableCrestt: boolean, controlName: string) {
    return enableCrestt && (controlName === 'mainApplicant.age' || controlName === "age");
}